import React from 'react';
import { Link } from 'react-router-dom';
import './SignupHeader.css';

const SignupHeader = ({ title }) => {
  return (
    <header className="signup-header">
      <div className="header-left">
        <button className="hamburger-btn">&#9776;</button>
        <Link to="/" className="logo-link">
          <div className="logo">CRISHI</div>
        </Link>
        <span className="header-separator">|</span>
        <div className="signup-title">{title}</div>
      </div>
      <a href="/" className="support-link">Support</a>
    </header>
  );
};

export default SignupHeader;